import React from 'react';

import { TableCell, TableRow } from '@mui/material';

interface Props {
  colSpan: number;
  label: string;
}

export default function EmptyTableRow({ colSpan, label }: Props) {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} sx={{ color: 'text.secondary', py: 3.5, textAlign: 'center' }}>
        {label}
      </TableCell>
    </TableRow>
  );
}
